export const menuData = [
  {
    key: "home",
    title: "Home",
    items: [],
    link: "/",
    private: false,
  },
  {
    key: "services",
    title: "Services",
    items: [],
    link: "/services",
    private: false,
  },
  {
    key: "products",
    title: "Products",
    items: [],
    link: "/products",
    private: false,
  },
  {
    key: "ourBranches",
    title: "Our Branches",
    items: [],
    link: "/our-branches",
    private: false,
  },
  {
    key: "offers",
    title: "Offers",
    items: [],
    link: "/offers",
    private: false,
  },
  {
    key: "aboutUs",
    title: "About US",
    items: [],
    link: "/about",
    private: false,
  },
  {
    key: "contactUs",
    title: "Contact Us",
    items: [],
    link: "/contact-us",
    private: false,
  },
];
